export function cleanSearchQuery (query: string): string {
  return query.indexOf('?') === 0 ? query.slice(1, query.length) : query;
}